import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 字体本地打包（国内访问 Google Fonts 不稳定）。只加载拉丁字符子集，中文走系统字体
import '@fontsource/chakra-petch/latin-600.css'
import '@fontsource/chakra-petch/latin-700.css'
import '@fontsource/ibm-plex-sans/latin-400.css'
import '@fontsource/ibm-plex-sans/latin-500.css'
import '@fontsource/ibm-plex-mono/latin-400.css'
import '@fontsource/ibm-plex-mono/latin-500.css'
import './assets/css/site.css'

import { initTracking } from './track'
initTracking()

// v-reveal：进入视口时淡入上移
const observer = typeof IntersectionObserver !== 'undefined'
  ? new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); observer.unobserve(e.target) }
      })
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' })
  : null

// 页面是构建时预渲染的（#app 里已有内容）：首屏可见的元素直接显示，避免挂载时闪一下
const prerendered = !!document.querySelector('#app > *')
const inView = el => { const r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0 }

const app = createApp(App)
app.directive('reveal', {
  mounted(el) {
    el.classList.add('reveal')
    if (!observer || (prerendered && inView(el))) el.classList.add('is-in')
    else observer.observe(el)
  },
  unmounted(el) { if (observer) observer.unobserve(el) },
})
app.use(router)
// 等路由（含按需加载的页面）准备好再挂载，否则预渲染的内容会先被清空、出现白屏
router.isReady().then(() => app.mount('#app'))
